/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ErrorDto model module.
 * @module model/ErrorDto
 * @version v0
 */
class ErrorDto {
    /**
     * Constructs a new <code>ErrorDto</code>.
     * @alias module:model/ErrorDto
     * @param statusCode {Number} Response status code
     * @param error {String} The message about the response
     * @param message {String} The message about the response
     */
    constructor(statusCode, error, message) { 
        
        ErrorDto.initialize(this, statusCode, error, message);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, statusCode, error, message) { 
        obj['statusCode'] = statusCode;
        obj['error'] = error;
        obj['message'] = message;
    }

    /**
     * Constructs a <code>ErrorDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ErrorDto} obj Optional instance to populate.
     * @return {module:model/ErrorDto} The populated <code>ErrorDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ErrorDto();

            if (data.hasOwnProperty('statusCode')) {
                obj['statusCode'] = ApiClient.convertToType(data['statusCode'], 'Number');
            }
            if (data.hasOwnProperty('error')) {
                obj['error'] = ApiClient.convertToType(data['error'], 'String');
            }
            if (data.hasOwnProperty('message')) {
                obj['message'] = ApiClient.convertToType(data['message'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ErrorDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ErrorDto</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of ErrorDto.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['error'] && !(typeof data['error'] === 'string' || data['error'] instanceof String)) {
            throw new Error("Expected the field `error` to be a primitive type in the JSON string but got " + data['error']);
        }
        // ensure the json data is a string
        if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
            throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
        }

        return true;
    }


}

ErrorDto.RequiredProperties = ["statusCode", "error", "message"];

/**
 * Response status code
 * @member {Number} statusCode
 */
ErrorDto.prototype['statusCode'] = undefined;

/**
 * The message about the response
 * @member {String} error
 */
ErrorDto.prototype['error'] = undefined;

/**
 * The message about the response
 * @member {String} message
 */
ErrorDto.prototype['message'] = undefined;






export default ErrorDto;

